import { ConfigResponse } from "@/app/api/config/route";
import { useQuery } from "@tanstack/react-query";

export async function getConfig() {
  return await fetch("/driver-portal/api/config");
}

export default function useGetConfig() {
  return useQuery<ConfigResponse>({
    queryKey: ["config"],
    queryFn: async () => {
      const response = await getConfig();
      return response.json();
    },
    staleTime: 1000,
  });
}
